import type {CustomerLogo} from '@/ui/logos-carousel';

export const LOGO_BASE = '/static/images/industry-technology/customer-logos';

/** `file` matches basename in customer-logos/ (without .png). */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  {file: 'Samsung_2x', label: 'Samsung', width: 220, height: 80},
  {file: 'Mercari_2x', label: 'Mercari', width: 180, height: 80},
  {file: 'Sinch_2x', label: 'Sinch', width: 180, height: 80},
  {file: 'Verint_2x', label: 'Verint', width: 180, height: 80},
  {file: 'Genetec_2x', label: 'Genetec', width: 180, height: 80},
  {file: 'Zerofox_2x', label: 'ZeroFox', width: 220, height: 80},
  {file: 'Datacom_2x', label: 'Datacom', width: 160, height: 80},
  {file: 'Civica_2x', label: 'Civica', width: 160, height: 80},
  {file: 'Corcentric_2x', label: 'Corcentric', width: 220, height: 80},
  {file: 'Treatwell_2x', label: 'Treatwell', width: 180, height: 80},
  {file: 'Trinetix_2x', label: 'Trinetix', width: 140, height: 80},
  {file: 'Jalasoft_2x', label: 'Jalasoft', width: 188, height: 80},
  {file: 'Testronic_2x', label: 'Testronic', width: 220, height: 80},
  {file: 'Mindex_2x', label: 'Mindex', width: 180, height: 80},
  {file: 'Credence_2x', label: 'Credence', width: 220, height: 48},
  {file: 'QualityAI_2x', label: 'Quality AI', width: 180, height: 80}
];
